import { Navigate, useLocation } from "react-router-dom";

import { isAnamnesePreviewNavigation } from "../anamnese-v2/utils/previewSession";
import useAnamneseVersion from "../hooks/useAnamneseVersion";
import {
  adultMapPath,
  collectionPath,
  hasV2Audience,
  isVersionV2,
  legacyCollectionPath,
  normalizeAudience,
} from "../utils/anamneseVersion";
import { peekStoredSubmissionUuid } from "../utils/anamneseEvaluationStore";

function inferredAudience(search, config) {
  const explicit = normalizeAudience(new URLSearchParams(search || "").get("audience"));
  if (explicit) return explicit;
  if (hasV2Audience("adulto", config)) return "adulto";
  if (hasV2Audience("kids", config)) return "kids";
  if (hasV2Audience("baby", config)) return "baby";
  return "adulto";
}

/**
 * Coleta/mapa do lado errado redirecionam. URLs de produto não usam este gate.
 */
export default function AnamneseVersionGate({ mode, children }) {
  const { ready, config } = useAnamneseVersion();
  const location = useLocation();
  const isPreview = isAnamnesePreviewNavigation(location);
  const search = location.search || "";

  if (!ready) {
    return children;
  }

  if (mode === "legacy-adult" && hasV2Audience("adulto", config)) {
    return <Navigate to={`${collectionPath("adulto", { config })}${search}`} replace />;
  }

  if (mode === "legacy-kids" && hasV2Audience("kids", config)) {
    const params = new URLSearchParams(search);
    const personaId = params.get("persona_id");
    return <Navigate to={collectionPath("kids", { config, personaId })} replace />;
  }

  if (mode === "legacy-baby" && hasV2Audience("baby", config)) {
    const params = new URLSearchParams(search);
    const personaId = params.get("persona_id");
    return <Navigate to={collectionPath("baby", { config, personaId })} replace />;
  }

  if (mode === "legacy-map" && hasV2Audience("adulto", config)) {
    return <Navigate to={adultMapPath(peekStoredSubmissionUuid(), config)} replace />;
  }

  if (mode === "v2-collection" && !isPreview) {
    if (!isVersionV2(config)) {
      return <Navigate to={legacyCollectionPath(inferredAudience(search, config))} replace />;
    }

    const path = location.pathname || "";
    const isEntry = path === "/anamnese-v2" || path === "/anamnese-v2/";
    if (isEntry) {
      const audience = inferredAudience(search, config);
      if (!hasV2Audience(audience, config)) {
        return <Navigate to={legacyCollectionPath(audience)} replace />;
      }
    }
  }

  return children;
}
